export const muiLinkTheme = {
  MuiLink: {
    variants: [
      {
        props: { variant: 'kitPrimary' },
        style: ({ theme }) => ({
          fontFamily: 'Inter',
          letterSpacing: 'inherit',
          color: theme.palette.kit.link.main,
          textDecoration: 'none',
          ':after': {
            content: '"→"',
            fontSize: 'inherit',
            fontFamily: 'Inter',
          },
          ':hover': {
            textDecoration: 'underline',
          },
          ':active': {
            textDecoration: 'none',
          },
        }),
      },
      {
        props: { variant: 'kitPrimaryInverse' },
        style: ({ theme }) => ({
          fontFamily: 'Inter',
          color: theme.palette.kit.link.inverse,
          textDecoration: 'none',
          ':after': {
            content: '"→"',
            fontSize: 'inherit',
            fontFamily: 'Inter',
          },
          ':hover': {
            textDecoration: 'underline',
          },
          ':active': {
            textDecoration: 'none',
          },
        }),
      },
      {
        props: { variant: 'kitSecondary' },
        style: ({ theme }) => ({
          fontSize: 16,
          fontFamily: 'Inter',
          color: theme.palette.kit.link.main,
          textDecoration: 'none',
          ':hover': {
            textDecoration: 'underline',
          },
          ':active': {
            textDecoration: 'none',
          },
        }),
      },
      {
        props: { variant: 'kitSecondaryInverseWhite' },
        style: ({ theme }) => ({
          fontSize: 16,
          fontFamily: 'Inter',
          color: theme.palette.kit.link.inverseWhite,
          opacity: 0.6,
          textDecoration: 'none',
          ':after': {
            content: '"→"',
            fontSize: 'inherit',
            fontFamily: 'Inter',
          },
          ':hover': {
            textDecoration: 'underline',
          },
          ':active': {
            textDecoration: 'none',
          },
        }),
      },
      {
        props: { variant: 'kitSecondaryInverse' },
        style: ({ theme }) => ({
          fontSize: 16,
          fontFamily: 'Inter',
          color: theme.palette.kit.link.inverse,
          textDecoration: 'none',
          ':hover': {
            textDecoration: 'underline',
          },
          ':active': {
            textDecoration: 'none',
          },
        }),
      },
      {
        props: { variant: 'kitSecondaryAccent' },
        style: ({ theme }) => ({
          fontSize: 16,
          fontFamily: 'Inter',
          color: theme.palette.kit.link.accent,
          textDecoration: 'none',
          ':hover': {
            textDecoration: 'underline',
          },
          ':active': {
            textDecoration: 'none',
          },
          [theme.breakpoints.down('sm')]: {
            fontSize: 14,
          },
        }),
      },
    ],
  },
};
